import React from "react";
import { Modal, Checkbox, Button } from "antd";
import { CopyOutlined } from "@ant-design/icons";

const CopyKOTModal = ({
  copyKOTVisible,
  setCopyKOTVisible,
  groupedFiredItems,
  selectedCopyItems,
  setSelectedCopyItems,
  handleCopyKOTConfirm,
}) => {
  return (
    <Modal
      title="Copy KOT"
      open={copyKOTVisible}
      onCancel={() => setCopyKOTVisible(false)}
      footer={null}
      width={520}
      styles={{ body: {
        height: "60vh",
        display: "flex",
        flexDirection: "column",
        paddingBottom: 0,
      } }}
    >
      <p style={{ marginTop: -5, color: "#6B7280" }}>Select items to copy and fire again</p>
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          paddingRight: 6,
          marginBottom: 20,
        }}
      >
        {Object.keys(groupedFiredItems).map((cat) => (
          <div key={cat} style={{ marginBottom: 20 }}>
            <p style={{ fontWeight: 600 }}>— {cat} —</p>

            {groupedFiredItems[cat].map((item) => {
              const isSelected = selectedCopyItems[item.productId] !== undefined;
              const qty = selectedCopyItems[item.productId] || 1;

              return (
                <div
                  key={item.productId}
                  style={{
                    background: isSelected ? "#EEF2FF" : "#F8FAFC",
                    border: "1px solid #E5E7EB",
                    padding: "10px 14px",
                    borderRadius: 8,
                    marginBottom: 8,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Checkbox
                    checked={isSelected}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedCopyItems((prev) => ({
                          ...prev,
                          [item.productId]: 1,
                        }));
                      } else {
                        setSelectedCopyItems((prev) => {
                          const updated = { ...prev };
                          delete updated[item.productId];
                          return updated;
                        });
                      }
                    }}
                  >
                    {item.name}

                    <span
                      style={{
                        background: "#22C55E",
                        color: "#fff",
                        padding: "2px 10px",
                        borderRadius: 6,
                        fontSize: "0.75rem",
                        marginLeft: 10,
                      }}
                    >
                      Fired
                    </span>
                  </Checkbox>
                  {isSelected && (
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <Button
                        size="small"
                        onClick={() => {
                          if (qty > 1) {
                            setSelectedCopyItems((prev) => ({
                              ...prev,
                              [item.productId]: qty - 1,
                            }));
                          }
                        }}
                        style={{ width: 32 }}
                      >
                        −
                      </Button>

                      <span>{qty}</span>

                      <Button
                        size="small"
                        onClick={() => {
                          setSelectedCopyItems((prev) => ({
                            ...prev,
                            [item.productId]: qty + 1,
                          }));
                        }}
                        style={{ width: 32 }}
                      >
                        +
                      </Button>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>
      {/* FOOTER BUTTONS */}
      <div style={{ textAlign: "right", marginBottom: 15 }}>
        <Button onClick={() => setCopyKOTVisible(false)}>Cancel</Button>

        <Button type="primary" icon={<CopyOutlined />} style={{ marginLeft: 10 }} disabled={Object.keys(selectedCopyItems).length === 0} onClick={handleCopyKOTConfirm}>
          Copy & Fire
        </Button>
      </div>
    </Modal>
  );
};

export default CopyKOTModal;
